<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-5.primary
          v-row(no-gutters)
            v-col
              p.mb-0.title.white--text New Image
            v-col.shrink
              v-btn.mr-n2(text icon @click="showModal = !showModal" height)
                v-icon(color="white" :size="24") mdi-close

        v-card-text.pa-0
          v-form(ref="form")
            v-card.pa-4(style="overflow-x: hidden;")
              div.mx-auto.container-image
                v-img(v-if="resizeImageFileUrl" :src="resizeImageFileUrl" max-height="300px")
                v-img(v-else height='140px', :src="require('@/assets/image_placeholder_measurement.png')")
                v-divider.grey
                v-card-actions.pa-0
                  v-row(dense)
                    v-col.py-0.pr-0
                      v-layout.file-layout
                        v-btn.mx-auto(color='primary' text block height="44")
                          | {{ $t('upload') }}
                        input.input-layout(type="file" @change="onFileChange" accept="image/*")
                    v-divider.grey(vertical)
                    v-col.py-0.pl-0
                      v-layout.file-layout
                        v-btn(color='primary', text block height="44")
                          | {{ $t('edit') }}
                        input.input-layout(type="file" @change="onFileChange" accept="image/*")
              
              .guide.mb-2(v-if="!resizeImageFileUrl")
                div.caption.mt-2.primary--text.text-center Maximum Image Filesize is 
                  b 10 MB
                div.caption.primary--text.text-center Recommended image size is 
                  b 960x960 px

        v-divider
        v-card-actions
          v-spacer
          v-btn(color='grey', text @click='showModal = false')
            | Cancel
          v-btn.mr-2(color='accent' depressed height=32 @click="clickSave" :loading="isLoading")
            div {{ $t('add') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'

export default {
  name: 'AddNewTenantImageDialog',
  props: ['open', 'settings', 'tenant'],
  data: () => ({
    resizeImageFileUrl: '',
    resizeImageFile: null,
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave() {
      if (!this.resizeImageFile) {
        this.showMessage(['error', this.$t('error_message.image_file_is_required')])
        return
      }
      this.isLoading = true
      var params = new FormData()
      params.append('image', this.resizeImageFile)
      this.axios.post(`/malls/${this.settings.mall.id}/branches/${this.settings.branch.id}/tenants/${this.company.slug}/images`, params)
        .then(resp => {
          this.showModal = false
          this.showMessage(['success', this.$t('success_message.image_added')])
          this.$emit('added', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      const resizedImage = await resizeImage(files[0], 'product_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    }
  }
}
</script>

<style scoped>
.container-image {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.background-inventory {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
}
</style>

